import React, { Component } from 'react'
import List2 from './list2.js'
import { Button, Modal, Table, Row } from 'react-bootstrap'
import { deepValue, getParams, end_point, makeUniqueKey, addStatus } from './helper'
import HamburgerNavbar from './hamburgerNavbar'
// import Footer from './footer';
import { getMonth } from './helper'
import { CSVLink } from 'react-csv'
import SearchBar from './searchBar'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { faChartBar } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios'


var $ = require('jquery');

class filteredListRosters extends Component {
  constructor(props) {
    super(props);
    const queryToken = getParams().jwt
    const storedToken = typeof window !== 'undefined' ? localStorage.getItem('jwt') : ''
    const token = queryToken && queryToken !== 'undefined' ? queryToken : storedToken
    this.state = {
      all_teams: [],
      token,
      filterableFields: this.props.filterableFields,
      labelFields: this.props.labelFields,
      endpoint: this.props.endpoint,
      selectedData: [],
      allData: [],
      selectedItem: null,
      searchBorder: "dashboard-box",
      searchTerm: localStorage.getItem(`rosterSearch.${getParams().organization_id || localStorage.getItem("organization_id")}.${this.props.heading || 'Rosters'}`) || '',
      head_coach: {},
      organization_id: localStorage.getItem("organization_id"),
      organization_name: localStorage.getItem("organization_name"),
      all_users: [],
      parentMap: {},
      organization_merch: [],
      athleteMap: {},
      authorized: null,
      showExportModal: false,
      selectedExportColumns: [],
      exportProgramId: null,
    }
  }

    componentDidMount() {
      this.loadPage();
    }

    editClicked = (selectedItem) => {
      this.editorUnclick();
      if (this.props.heading === 'Rosters') {
        window.location.href = document.location.origin + "/rosters?jwt=" + this.state.token +"&program_id=" + selectedItem._id +"&program_name=" + selectedItem.group_name;
      } else if (this.props.heading === 'Virtual Training') {
        window.location.href = document.location.origin + "/broadcast?jwt=" + this.state.token + "&program_id=" + selectedItem._id +"&program_name=" + selectedItem.group_name;
      }
    }

    editorUnclick = () => {
      this.setState({ searchBorder: "dashboard-box" })
    }

    editorClick = () => {
      this.setState({ searchBorder: "dashboard-box-orange" })
    }

    getSearchStorageKey = () => {
      return `rosterSearch.${this.state.organization_id}.${this.props.heading || 'Rosters'}`
    }

    getExportStorageKey = () => {
      return `rosterExportColumns.${this.state.organization_id}`
    }

    getExportColumnDefinitions = () => {
      const orgUDFs = this.state.orgUDFs || []
      const baseColumns = [
        { key: 'season', label: 'Season', group: 'Program Details', value: (ctx) => ctx.program.season || '' },
        { key: 'age_group', label: 'Age Group', group: 'Program Details', value: (ctx) => ctx.program.ages || '' },
        { key: 'division', label: 'Division', group: 'Program Details', value: (ctx) => ctx.program.division || '' },
        { key: 'group_name', label: 'Group Name', group: 'Program Details', value: (ctx) => ctx.program.group_name || '' },
        { key: 'enrolment_status', label: 'Enrolment Status', group: 'Program Details', value: (ctx) => ctx.enrolledStatus || '' },
        { key: 'organization_name', label: 'Organization Name', group: 'Program Details', value: (ctx) => ctx.organizationName || '' },
        { key: 'team_name', label: 'Team Name', group: 'Program Details', value: (ctx) => ctx.assignedTeamName || '' },
        { key: 'athlete_first', label: 'Athlete First', group: 'Athlete Details', value: (ctx) => ctx.athlete.first_name || '' },
        { key: 'athlete_last', label: 'Athlete Last', group: 'Athlete Details', value: (ctx) => ctx.athlete.last_name || '' },
        { key: 'athlete_gender', label: 'Athlete Gender', group: 'Athlete Details', value: (ctx) => ctx.athlete.gender || '' },
        { key: 'athlete_dob', label: 'Athlete DOB', group: 'Athlete Details', value: (ctx) => ctx.dateOfBirth || '' },
        { key: 'address', label: 'Address', group: 'Parent Details', value: (ctx) => ctx.athlete.address || '' },
        { key: 'city', label: 'City', group: 'Parent Details', value: (ctx) => ctx.athlete.city || '' },
        { key: 'province', label: 'Province/State', group: 'Parent Details', value: (ctx) => ctx.athlete.province || '' },
        { key: 'postal_code', label: 'Postal/Zip', group: 'Parent Details', value: (ctx) => ctx.athlete.postal_code || '' },
        { key: 'parent_name', label: 'Parent Name', group: 'Parent Details', value: (ctx) => `${ctx.parent.first_name || ''} ${ctx.parent.last_name || ''}`.trim() },
        { key: 'parent_phone', label: 'Parent Phone', group: 'Parent Details', value: (ctx) => ctx.parent.phone || '' },
        { key: 'parent_email', label: 'Parent Email', group: 'Parent Details', value: (ctx) => ctx.parent.email || '' },
        { key: 'secondary_name', label: 'Secondary Name', group: 'Parent Details', value: (ctx) => ctx.parent.secondary_name || '' },
        { key: 'secondary_phone', label: 'Secondary Phone', group: 'Parent Details', value: (ctx) => ctx.parent.secondary_phone || '' },
        { key: 'secondary_email', label: 'Secondary Email', group: 'Parent Details', value: (ctx) => ctx.parent.secondary_email || '' },
        { key: 'plan_name', label: 'Plan Name', group: 'Registration / Billing', value: (ctx) => ctx.user.plan_name || '' },
        { key: 'promo_code_name', label: 'Promo Code Name', group: 'Registration / Billing', value: (ctx) => ctx.user.promo_code || '' },
        { key: 'current_school', label: 'Current School', group: 'Athlete Details', value: (ctx) => ctx.athlete.current_school || '' },
        { key: 'enrolment_notes', label: 'Enrolment Notes', group: 'Athlete Details', value: (ctx) => ctx.athlete.enrolment_notes || '' },
      ]

      const udfColumns = orgUDFs.map((udf, index) => ({
        key: `udf:${udf.key}`,
        label: udf.label,
        group: 'Custom Fields',
        value: (ctx) => (ctx.athlete.udfs && ctx.athlete.udfs[index] ? ctx.athlete.udfs[index] : ''),
      }))

      return [...baseColumns, ...udfColumns]
    }

    getDefaultExportColumns = () => {
      return this.getExportColumnDefinitions().map((column) => column.key)
    }

    getSelectedExportColumns = () => {
      const availableKeys = this.getExportColumnDefinitions().map((column) => column.key)
      const selected = this.state.selectedExportColumns.length ? this.state.selectedExportColumns : this.getDefaultExportColumns()
      return selected.filter((column) => availableKeys.includes(column))
    }

    syncExportColumns = (orgUDFs = this.state.orgUDFs || []) => {
      const availableKeys = this.getExportColumnDefinitions().map((column) => column.key)
      const savedSelection = localStorage.getItem(this.getExportStorageKey())
      let selectedExportColumns = availableKeys

      if (savedSelection) {
        try {
          const parsedSelection = JSON.parse(savedSelection)
          if (Array.isArray(parsedSelection) && parsedSelection.length > 0) {
            selectedExportColumns = parsedSelection.filter((column) => availableKeys.includes(column))
            if (selectedExportColumns.length === 0) {
              selectedExportColumns = availableKeys
            }
          }
        } catch (error) {
          selectedExportColumns = availableKeys
        }
      }

      this.setState({
        orgUDFs,
        selectedExportColumns,
      })
    }

    handleExportModalOpen = () => {
      if (!this.state.selectedExportColumns.length) {
        this.syncExportColumns(this.state.orgUDFs || [])
      }
      this.setState({ showExportModal: true, exportProgramId: null })
    }

    handleProgramExport = (program) => {
      if (!this.state.selectedExportColumns.length) {
        this.syncExportColumns(this.state.orgUDFs || [])
      }
      this.setState({ showExportModal: true, exportProgramId: program._id })
    }

    handleExportModalClose = () => {
      this.setState({ showExportModal: false })
    }

    handleExportColumnToggle = (columnKey) => {
      this.setState((prevState) => {
        const nextColumns = prevState.selectedExportColumns.includes(columnKey)
          ? prevState.selectedExportColumns.filter((key) => key !== columnKey)
          : [...prevState.selectedExportColumns, columnKey]

        localStorage.setItem(this.getExportStorageKey(), JSON.stringify(nextColumns))
        return { selectedExportColumns: nextColumns }
      })
    }

    handleSelectAllExportColumns = () => {
      const selectedExportColumns = this.getExportColumnDefinitions().map((column) => column.key)
      localStorage.setItem(this.getExportStorageKey(), JSON.stringify(selectedExportColumns))
      this.setState({ selectedExportColumns })
    }

    handleClearExportColumns = () => {
      localStorage.setItem(this.getExportStorageKey(), JSON.stringify([]))
      this.setState({ selectedExportColumns: [] })
    }

    applyExportPreset = (presetName) => {
      const allColumns = this.getExportColumnDefinitions()
      const presetMap = {
        minimal: ['season', 'group_name', 'team_name', 'athlete_first', 'athlete_last', 'enrolment_status'],
        parent_contact: ['season', 'group_name', 'team_name', 'athlete_first', 'athlete_last', 'parent_name', 'parent_phone', 'parent_email', 'secondary_name', 'secondary_phone', 'secondary_email'],
        full: allColumns.map((column) => column.key),
      }

      const selectedExportColumns = presetMap[presetName] || presetMap.full
      localStorage.setItem(this.getExportStorageKey(), JSON.stringify(selectedExportColumns))
      this.setState({ selectedExportColumns })
    }

    buildRosterCSV = (programMap) => {
      const definitions = this.getExportColumnDefinitions()
      const selectedKeys = this.getSelectedExportColumns()
      const selectedDefinitions = definitions.filter((definition) => selectedKeys.includes(definition.key))
      const csvData = [selectedDefinitions.map((definition) => definition.label)]

      if (!selectedDefinitions.length) {
        return csvData
      }

      this.state.selectedData.forEach((program) => {
        const programDetails = programMap[program._id]
        if (!programDetails) {
          return
        }

        const organizationName = program.organization_id === this.state.organization_id ? this.state.organization_name : 'Ext Org'
        const enrolledUsers = Array.isArray(program.enrolled_users) ? program.enrolled_users : []

        enrolledUsers.forEach((user) => {
          const athlete = this.state.athleteMap[user._id]
          if (!athlete) {
            return
          }

          const parent = this.state.parentMap[athlete.parent_id] || {}
          const time = athlete.date_of_birth ? new Date(athlete.date_of_birth) : null
          const dateOfBirth = time ? `${getMonth(time.getMonth() + 1)} ${time.getDate()} ${time.getFullYear()}` : ''
          const assignedTeamName = user.team || program.group_name || ''
          const userMerch = programDetails.enrolled_users[`${user._id}${user.number}`] || {}

          const context = {
            program,
            programDetails,
            team: { name: assignedTeamName },
            assignedTeamName,
            athlete,
            parent,
            organizationName,
            enrolledStatus: userMerch.status || user.status || '',
            dateOfBirth,
            user,
          }

          const row = selectedDefinitions.map((definition) => `${definition.value(context) || ''}`)
          csvData.push(row)
        })
      })

      return csvData
    }

    loadPage = () => {
      var rthis = this
      $.ajax({
        headers: {
          "token": this.state.token,
          "organization_id": this.state.organization_id,
          "user_type": "coachadmin"
        },
        method: "GET",
        dataType: "json",
        url: `${end_point('users')}/users`,//maybe create an endpoint dedicated for returning coaches
      }).then(data => this.handleCoach(data.message));

      $.ajax({
        headers: {
          "token": this.state.token,
          "organization_id": this.state.organization_id,
        },
        method: "GET",
        dataType: "json",
        url: `${end_point('users')}/users`,
        success: function (data) {
          if (data.errorMessage) {
            rthis.setState({ authorized: false })
          } else {
            rthis.handleUsers(data.message)
          }
        }
      })//.then(data => this.handleUsers(data.message));

      $.ajax({
          headers: {
            "token": this.state.token,
            "organization_id": this.state.organization_id
          },
          method: "GET",
          dataType: "json",
          url: `${end_point('organizations')}/organizations`,
      }).then(data => {
        console.log('org data - udfs?', data)
        this.setState({
          organization_name: data.name,
          organization_merch: data.merch,
          orgUDFs: data.udfs ? data.udfs : null
        }, () => {
          this.syncExportColumns(data.udfs ? data.udfs : [])
        })
      })

      $.ajax({
        headers: {
          "token": this.state.token,
          "organization_id": this.state.organization_id
        },
        method: "GET",
        dataType: "json",
        url: this.state.endpoint,
        success: function (data) {
          if (data.errorMessage) {
            alert(data.errorMessage);
          } else {
            console.log("after get programs", data)
            rthis.dataTransform(data)
          }
        },
        error: function (err){
          alert('Not authorized');
          window.location.href = document.location.origin + "/portals?jwt=" + rthis.state.token + (rthis.state.organization_id ? ("&organization_id=" + rthis.state.organization_id) : "");
        }
      })
    }

    handleUsers(data){
      var parentMap = {}
      var athleteMap = {}
      const { orgUDFs } = this.state
      data.forEach(user => {
        if (user.type === 'parent' || user.type === 'admin' || user.type === 'manager') {
          parentMap[user._id] = {
            'first_name': user.first_name,
            'last_name': user.last_name,
            'email': user.email,
            'phone':user.extras.phone,
            'secondary_name': user.type === 'parent' ? `${user.extras.secondary_parent.first_name} ${user.extras.secondary_parent.last_name}`: '-',
            'secondary_phone': user.type === 'parent' ? user.extras.secondary_parent.phone: '-',
            'secondary_email': user.type === 'parent' ? user.extras.secondary_parent.email: '-'
          }
        }
      })
      data.forEach(user => {
        if (user.type === 'athlete') {
          athleteMap[user._id] = {
            'first_name': user.first_name,
            'last_name': user.last_name,
            'parent_id': user.parent_id,
            'email': user.email,
            'phone': user.extras.phone,
            'date_of_birth': user.extras.date_of_birth,
            'address':user.extras.address,
            'province': user.extras.province,
            'city': user.extras.city,
            'postal_code': user.extras.postal_code,
            'gender': user.extras.gender,
            'current_school': user.extras.current_school,
            'enrolment_notes': user.extras.parent_notes
          }
        if (user.udfs && orgUDFs) {
          athleteMap[user._id].udfs = []
          orgUDFs.forEach(orgUDF => {
            var userUDF = user.udfs.find(udf => { return udf.organization_id === this.state.organization_id && orgUDF.key === udf.key})
            if (userUDF) {
              var quotation = typeof userUDF.value === "string" ? userUDF.value.includes(`"`) : null
              if (quotation) {
                var newValue = userUDF.value.replace(/"/g, '""')
                userUDF.value = newValue
              }
              athleteMap[user._id].udfs.push(`${userUDF.value}`)
            } else {
              athleteMap[user._id].udfs.push('-')
            }
          })
        } else if (orgUDFs && !user.udfs) {
          athleteMap[user._id].udfs = []
          orgUDFs.forEach(orgUDF => {
            athleteMap[user._id].udfs.push('-')
          })
        }
       }
      })
      this.setState({ athleteMap, parentMap, all_users: data, authorized: true})
    }

    handleCoach(data) {
      var coach_container = {}
      data.forEach(coach => {
        coach_container[coach["_id"]] = `${coach["first_name"]} ${coach["last_name"]}`
      })
      this.setState({ head_coach: coach_container })
    }

    dataTransform(data) {
      var temp_data = addStatus(data);
      var tempInitialData = this.addSearchField(temp_data.message);
      console.log('tempInitialData', tempInitialData)
      if (this.props.heading === "Virtual Training") {
        var VTprograms = []
        tempInitialData.forEach(program => {
          if (program.VTsessions && program.VTsessions.length > 0) {
            VTprograms.push(program)
          }
        })
        tempInitialData = VTprograms
      }
      this.setState({
        selectedData: this.applyRosterSearchFilter(tempInitialData, this.state.searchTerm),
        allData: tempInitialData
      });
    }

    applyRosterSearchFilter = (originalList, searchTerm = '') => {
      const normalized = (searchTerm || '').trim().toLowerCase()
      if (!normalized) {
        return originalList
      }

      const searchWords = normalized.split(',')
      return originalList.filter((item) => {
        return searchWords.every((currentValue) => {
          return item.searchField.toLowerCase().indexOf(currentValue.toLowerCase().trim()) !== -1
        })
      })
    }

  addSearchField(data) {
    data.forEach((elem, index) => {
      var searchField = "";
      this.state.filterableFields.forEach((objectPath) => {
        let field;
        if (objectPath === "head_coach") {
          field = this.state.head_coach[deepValue(elem, objectPath)];
        } else if (objectPath === "start_date") {
          const date = deepValue(elem, objectPath);
          field = `${getMonth(date.slice(5,7))} ${date.slice(8,10)}, ${date.slice(0,4)}`;
            //var field = deepValue(elem, objectPath).slice(0,10);
        } else {
          field = deepValue(elem, objectPath);
        }
        if (field) {
          searchField = searchField + " " + field;
        }
      })
      data[index].searchField = searchField;
      })
      return data;
    }

  filterList = (event) => {
    const searchTerm = event && event.target ? event.target.value : this.state.searchTerm
    localStorage.setItem(this.getSearchStorageKey(), searchTerm)
    this.setState({
      searchTerm,
      selectedData: this.applyRosterSearchFilter(this.state.allData, searchTerm)
    });
  }

    render() {
    const { organization_merch, all_users, authorized } = this.state
    const className = `${this.state.searchBorder} margin-2 search-bar`
    var teamDataCSV = []
    var programs = this.state.selectedData.slice()
    if (this.state.exportProgramId) {
      programs = programs.filter(program => program._id === this.state.exportProgramId)
    }
    var programMap = {}
    programs.forEach(program => {
      var enrolled_users = {}
      program.enrolled_users.forEach( user => {
        enrolled_users[ `${user._id}${user.number}` ] = {
          'first_name': user.first_name,
          'last_name': user.last_name,
          'merch': user.merch,
          'status': user.status
        }
      })
      programMap[program._id] = {
        'season': program.season,
        'division': program.division,
        'ages': program.ages,
        'group_name': program.group_name,
        'enrolled_users': enrolled_users
      }
    })

    console.log({organization_merch, all_users, selectedData: this.state.selectedData})
    if (organization_merch.length !== 0 && all_users.length !==0 && this.state.selectedData.length !== 0) {
      teamDataCSV = this.buildRosterCSV(programMap)
    }
    const hasRosterData = teamDataCSV.length > 1
    const exportColumns = this.getExportColumnDefinitions()
    const selectedExportColumns = this.getSelectedExportColumns()
    const exportGroups = exportColumns.reduce((groups, column) => {
      groups[column.group] = groups[column.group] || []
      groups[column.group].push(column)
      return groups
    }, {})
    return (
      <div className="full-page">
        <HamburgerNavbar />

        <div className="search-page-wrapper programs-page-wrapper">
          <div className="programs-page-hero">
            <div className="programs-page-copy">
              <div className="programs-page-kicker">Admin Console</div>
              <h2 className="pagetitle programs-page-title">
                <span>{this.props.heading}</span>
              </h2>
            </div>
          </div>

          <Row className="searchbox-container programs-searchbar">
            <SearchBar className={className} filterList={this.filterList} editorUnclick={this.editorClick} value={this.state.searchTerm} />
            {authorized && this.props.heading !== "Virtual Training" && (
              <ExportButton onClick={this.handleExportModalOpen} disabled={!hasRosterData} />
            )}
          </Row>

          <div className="programs-grid programs-table-shell">
            <Table className="tb-grid rosters-table-header">
              <tbody>
                <tr>
                  {
                    this.state.labelFields.map((field) =>
                      <td
                        key={makeUniqueKey()}
                        style={{ borderTop: "none", width: field.size, backgroundColor: "#edf1f5", color: "#0f172a" }}
                        className={field.name === "program_info" ? "rosters-program-stats-header" : ""}
                      >
                        {field.name === "program_info" ? (
                          <span className="rosters-program-stats-trigger" title="Enrolled / Maximum / Flex">
                            <FontAwesomeIcon icon={faChartBar} className="rosters-program-stats-icon" />
                          </span>
                        ) : (
                          field.name ==="start_date" ? field.name.replace(/start_date/g, "Program Start") : (field.name ==="ages" ? field.name.replace(/ages/g, "Age Group") : field.name.replace(/\.|_|extras.|payment_gateway.|price_breakdown./g, " ").split(' ').map(s => s.charAt(0).toUpperCase() + s.slice(1)).join(' '))
                        )}
                      </td>)
                  }
                </tr>
              </tbody>
            </Table>
            <List2
              data={this.state.selectedData}
              labelFields={this.state.labelFields}
              head_coach={this.state.head_coach}
              downloadProgram={this.handleProgramExport}
              action={this.editClicked} />
          </div>
        </div>

        <Modal show={this.state.showExportModal} onHide={this.handleExportModalClose} dialogClassName="roster-export-modal">
          <Modal.Header closeButton>
            <Modal.Title>Choose export columns</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{maxHeight: '65vh', overflowY: 'auto'}}>
            <p className="roster-export-note">Select the fields to include in the CSV download. Your last selection is remembered for this organization.</p>
            <div className="roster-export-presets">
              <Button type="button" className="programs-action-btn programs-action-btn-neutral" onClick={() => this.applyExportPreset('minimal')}>Minimal</Button>
              <Button type="button" className="programs-action-btn programs-action-btn-neutral" onClick={() => this.applyExportPreset('parent_contact')} style={{marginLeft: '8px'}}>Parent Contact</Button>
              <Button type="button" className="programs-action-btn programs-action-btn-neutral" onClick={() => this.applyExportPreset('full')} style={{marginLeft: '8px'}}>Full Export</Button>
            </div>
            <div className="roster-export-toolbar">
              <Button type="button" className="programs-action-btn programs-action-btn-neutral" onClick={this.handleSelectAllExportColumns}>Select All</Button>
              <Button type="button" className="programs-action-btn programs-action-btn-neutral" onClick={this.handleClearExportColumns} style={{marginLeft: '8px'}}>Clear All</Button>
            </div>
            {Object.keys(exportGroups).map((groupName) => (
              <div className="roster-export-group" key={groupName}>
                <div className="roster-export-group-title">{groupName}</div>
                <div className="roster-export-grid">
                  {exportGroups[groupName].map((column) => (
                    <label className="roster-export-option" key={column.key}>
                      <input
                        type="checkbox"
                        checked={selectedExportColumns.includes(column.key)}
                        onChange={() => this.handleExportColumnToggle(column.key)}
                      />
                      <span>{column.label}</span>
                    </label>
                  ))}
                </div>
              </div>
            ))}
          </Modal.Body>
          <Modal.Footer>
            <Button type="button" className="programs-action-btn programs-action-btn-neutral" onClick={this.handleExportModalClose}>Close</Button>
            {hasRosterData ? (
              <CSVLink
                style={{color: 'white'}}
                filename={"hoopstir-teams.csv"}
                target="_self"
                data={teamDataCSV}
                onClick={this.handleExportModalClose}
              >
                <Button className="searchbtn programs-action-btn programs-action-btn-neutral" type="button">Download CSV</Button>
              </CSVLink>
            ) : (
              <Button className="searchbtn programs-action-btn programs-action-btn-neutral" type="button" disabled={true}>Download CSV</Button>
            )}
          </Modal.Footer>
        </Modal>
      </div>
      )
  }

}

const ExportButton = ({onClick, disabled}) => {
  return (
    <Button
      className="searchbtn programs-action-btn programs-action-btn-neutral"
      type="button"
      onClick={onClick}
      disabled={disabled}
    >
      Download Rosters
    </Button>
  )
}

export default filteredListRosters;
